import { IconType } from 'react-icons';
import {
  ClaimStatusHistoryWrapper,
  ClaimStatusHistoryContent,
  ClaimStatusSection,
  IconWrapper,
} from './styles';

export type TagType = 'normal' | 'warning' | 'error' | 'default';

export interface StepClaimStatus {
  status?: string;
  date?: Date;
  description?: string;
  icon?: IconType;
  color?: TagType;
}

export function ClaimStatusHistory({
  date,
  status,
  color,
  icon: Icon,
  description,
}: Readonly<StepClaimStatus>) {
  return (
    <ClaimStatusSection>
      <ClaimStatusHistoryWrapper color={color}>
        <header>{status && <span className="tag">{status}</span>}</header>
        <IconWrapper color={color}>
          <div className="icon">{Icon && <Icon />}</div>
        </IconWrapper>
        <ClaimStatusHistoryContent color={color}>
          <span className="text">{description}</span>
          {date && <span className="date">{date.toString()}</span>}
        </ClaimStatusHistoryContent>
      </ClaimStatusHistoryWrapper>
    </ClaimStatusSection>
  );
}
